import { action as apiAction } from 'api/Api'
import {
  setStartDate as setCardStartDate,
  setStartDateId as setCardStartDateId
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
}

export default (payload: Payload) => async dispatch => {
  const { id } = payload

  const optimisticAction = optimisticDispatch(dispatch, [
    setCardStartDate({
      id,
      startDate: null
    }),
    setCardStartDateId({
      id,
      startDateId: null
    })
  ])

  try {
    await apiAction('RemoveStartDate', {
      cardId: id
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}
